<app-create-bank-group [visible]="createDrawerVisible" (visibleChange)="createDrawerVisible = $event; createDrawerVisibleChange.emit($event)" (saved)="loadBankGroupData()" />
<app-update-bank-group [visible]="updateDrawerVisible" (visibleChange)="updateDrawerVisible = $event; updateDrawerVisibleChange.emit($event)" [id]="bankGroupIdEditing" />

<div class="card border-0">
  <div class="card-body">
    <p-table [value]="listBankGroup" dataKey="id" showGridlines [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template #header>
        <tr>
          <th style="width: 50px">ID</th>
          <th>Grupo</th>
          <th>Banco</th>
          <th>Titular</th>
          <th colspan="2">Fecha de registro</th>
        </tr>
      </ng-template>
      <ng-template #body let-item>
        <tr>
          <td>{{ item.userBankGroupId }}</td>
          <td>{{ item.label }}</td>
          <td>{{ item.bankAccount?.BANCO }}</td>
          <td>{{ item.bankAccount?.TITULAR }}</td>
          <td style="width: 200px">{{ item.dateCreated | date: "longDate" }}</td>
          <td style="width: 10px">
            <div class="d-flex gap-2">
              <p-button icon="pi pi-pencil" class="p-button-text" (click)="updateBankGroup(item.userBankGroupId)" />
              <p-button icon="pi pi-trash" severity="danger" class="p-button-text" (click)="delete($event, item.userBankGroupId)" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
